export { StrapiImage } from './StrapiImage';
